import React, { useRef, useEffect } from 'react';
import { Download } from 'lucide-react';

const OptionsMenu = ({ onExportExcel, onExportPDF, showExport, anchorRef, isOpen, onClose }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target) && anchorRef?.current && !anchorRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose, anchorRef]);

  if (!isOpen) return null;

  return (
    <div
      ref={menuRef}
      className="absolute right-0 top-full mt-2 w-64 bg-white rounded-xl shadow-lg border border-gray-200 py-2 z-50"
    >
      <div className="px-4 py-2 border-b border-gray-100">
        <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Options</p>
      </div>
      {showExport && (
        <>
          <button
            type="button"
            onClick={() => { onExportExcel(); onClose(); }}
            className="w-full flex items-center gap-3 px-4 py-3 text-left text-sm text-gray-700 hover:bg-gray-50 transition-colors"
          >
            <Download size={18} className="text-[#679632]" />
            <span>Export to Excel</span>
          </button>
          <button
            type="button"
            onClick={() => { onExportPDF?.(); onClose(); }}
            className="w-full flex items-center gap-3 px-4 py-3 text-left text-sm text-gray-700 hover:bg-gray-50 transition-colors"
          >
            <Download size={18} className="text-[#679632]" />
            <span>Export to PDF</span>
          </button>
        </>
      )}
      {!showExport && (
        <p className="px-4 py-3 text-sm text-gray-500">Export available on Pre Sales, Post Sales, Potential Clients, and Onboarded Clients.</p>
      )}
    </div>
  );
};

export default OptionsMenu;
